import { Tab, Tabs } from "@material-ui/core";
import { useEffect, useState } from "react";
import clsx from "clsx";
import _ from "lodash";
import {decodeHtml} from "../../utils/helpers";

export const CategoryBubble = ({ data, handleSelect }) => {
	const [categories, setCategories] = useState([]);

	function handleClickCategory(item) {
		let queryCategory = "";

		const changedCats = _.map(categories, (cat) => {
			if (cat.id == item.id && !cat.active) {
				cat.active = true;
				queryCategory = cat.queryParam;
			} else cat.active = false;
			return cat;
		});

		const activeCat = _.find(changedCats, (e) => e.active == true);

		const catAllIdx = _.findIndex(changedCats, (c) =>
			c.hasOwnProperty("isCategoryAll")
		);

		if (!activeCat?.queryParam) {
			changedCats[catAllIdx].active = true;

			queryCategory = null;
		} else {
			changedCats[catAllIdx].active = false;
		}

		setCategories(changedCats);

		handleSelect(queryCategory);
	}

	useEffect(() => {
		data && data.length && setCategories(data);
	}, [data.length]);
	return (
		<div className="tabsRoot" style={{ maxWidth: 860, paddingLeft: 5 }}>
			<Tabs
				variant="scrollable"
				scrollButtons="auto"
				aria-label="scrollable auto tabs example"
			>
				{_.map(categories, (item) => {
					return (
						<Tab
							onClick={(e) => handleClickCategory(item)}
							key={item.id}
							label={decodeHtml(item.name)}
							value={item.id}
							className={clsx({
								"topic-52": true,
								active: item.active,
							})} 
							style={{ display: (item.name.toLowerCase()=='ignore category' || item.name.toLowerCase()=='ignore category ar')? "none":"block" }}
						/>
					);
				})}
			</Tabs>
		</div>
	);
};
